/* eslint-disable */
import React, { useContext } from "react";
import { useEffect, useCallback, useState, useRef } from "react";
import "../styles/OtherSessions.css";
import { Context } from "../services/Context";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import AWS from "aws-sdk";

const OtherSessions = () => {
  const {
    CrudApi,
    listOfPlayers,
    currentSession,
    videoCurrentSession,
    isSaveCurrentSession,
    showSessionType,
    infoSession,
    translate,
    userContext
  } = useContext(Context);
  const [sessions, setSessions] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const [isSorted, setIsSorted] = useState(false);
  const navigate = useNavigate();
  const [sessionType, setSessionType] = useState([]);
  const [group, setGroup] = useState([]);
  const [user, setUser] = useState([]);

  const isMountedRef = useRef(true);

  const getSessions = useCallback(async () => {
    let playersToUse = listOfPlayers.current;

    // Si no hay jugadores cargados, intentar cargarlos antes de obtener sesiones
    if (!playersToUse || playersToUse.length === 0) {
      if (userContext?.userId) {
        try {
          const response = await CrudApi.get(`user/${userContext.userId}/players`);
          if (response.Players && response.Players.length > 0) {
            listOfPlayers.current = response.Players;
            playersToUse = response.Players;
          } else {
            // Si el usuario realmente no tiene jugadores, no podemos hacer mucho
            setIsSorted(true);
            return;
          }
        } catch (error) {
          console.error("Error al cargar jugadores en OtherSessions:", error);
          setIsSorted(true);
          return;
        }
      } else {
        navigate("/");
        return;
      }
    }

    if (playersToUse && playersToUse.length) {
      let players = [];
      let groups = [];
      let allSessions = [];

      try {
        const requests = playersToUse.map(async (player) => {
          const res = await CrudApi.get(`player/${player.playerId}/sessions`);
          if (res.Sessions && res.Sessions.length) {
            return {
              sessions: res.Sessions,
              playerName: player.Name + " " + player.Surname,
              sportGroup: player.SportGroup
            };
          }
          return null;
        });
  // ...

        const results = await Promise.all(requests);
        
        results.forEach(result => {
          if (result) {
            players.push(result.playerName);
            groups.push(result.sportGroup);
            allSessions.push(...result.sessions);
          }
        });

        if (allSessions.length) {
          allSessions.sort((a, b) => {
            const extractDateAndTime = (url) => {
              if (!url || typeof url !== "string") return "";
              const match = url.match(/(\d{4}-\d{2}-\d{2})\/(\d{2}_\d{2}_\d{2})/);
              if (!match) return "";
              const [, datePart, timePart] = match;
              return `${datePart} ${timePart.replace(/_/g, ":")}`;
            };
            const dateA = new Date(extractDateAndTime(a.videoURL));
            const dateB = new Date(extractDateAndTime(b.videoURL));
            return dateB - dateA;
          });

          if (isMountedRef.current) {
            setSessions(allSessions);
            setGroup([...new Set(groups)]);
            setUser([...new Set(players)]);
            setSessionType([...new Set(allSessions.map(s => s.sessionType))]);
            setIsSorted(true);
          }
        } else {
          if (isMountedRef.current) {
            setSessions([]);
            setIsSorted(true);
          }
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      navigate("/football-session");
    }
  }, [listOfPlayers, CrudApi, navigate]);

  useEffect(() => {
    isMountedRef.current = true;
    
    setSessions([]);
    setIsSorted(false);
    setSelectedSession(null);
    
    if (userContext) {
      getSessions();
    }

    return () => {
      isMountedRef.current = false;
    };
  }, [userContext, getSessions]);

  const handleToAnalizeSession = () => {
    if (videoCurrentSession.current && !isSaveCurrentSession.current) {
      Swal.fire({
        title: translate("sesion_sin_guardar"),
        text: translate("si_continuar"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: translate("si_continuar"),
        cancelButtonText: translate("no"),
        reverseButtons: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          videoCurrentSession.current = null;
          currentSession.current = selectedSession;
          navigate("/analize-session/" + selectedSession[0].sessionId);
        }
      });
    } else {
      currentSession.current = selectedSession;
      navigate("/analize-session/" + selectedSession[0].sessionId);
    }
  };

  const handleSelectSession = (session, currentPlayer) => {
    setSelectedSession([session, currentPlayer]);
  };
  const calculateAge = (birthday) => {
    let today = new Date();
    let birthDate = new Date(birthday);
    let age = today.getFullYear() - birthDate.getFullYear();
    let month = today.getMonth() - birthDate.getMonth();
    if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const deleteMinioFile = async (fileName) => {
    try {
      await CrudApi.delete(`minio/${encodeURIComponent(fileName)}`);
      console.log(`Archivo ${fileName} eliminado correctamente`);
    } catch (error) {
      console.error("Error eliminando archivo en MinIO:", error);
    }
  };

  const deleteSelectedSession = () => {
    Swal.fire({
      title: translate("seguro_procesar"),
      text: translate("no_revertir"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: translate("si_eliminar"),
      cancelButtonText: translate("cancelar"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await CrudApi.delete(`sessions/${selectedSession[0].sessionId}`);

          for (const move of selectedSession[0].SessionMoves) {
            await deleteMinioFile(move.imageUrl);
          }
          await deleteMinioFile(selectedSession[0].videoURL);
          if (selectedSession[0].imageCalibration) {
            await deleteMinioFile(selectedSession[0].imageCalibration);
          }

          Swal.fire(translate("eliminado"), translate("sesion_eliminada"), "success");
          getSessions();
        } catch (error) {
          console.error(error);
          Swal.fire(translate("error"), translate("sesion_no_eliminada"), "error");
        }
      }
    });
  };


  const [sessionTypeFilter, setSessionTypeFilter] = useState("all");
  const [groupFilter, setGroupFilter] = useState("all");
  const [userFilter, setUserFilter] = useState("all");

  const handleChangeSessionTypeFilter = (event) => {
    setSessionTypeFilter(event.target.value);
  };

  const handleChangeGroupFilter = (event) => {
    setGroupFilter(event.target.value);
  };

  const handleChangeUserFilter = (event) => {
    setUserFilter(event.target.value);
  };

  const filteredSessions = sessions.filter((session) => {
    if (
      sessionTypeFilter !== "all" &&
      session.sessionType !== sessionTypeFilter
    ) {
      return false;
    }
    if (groupFilter !== "all") {
      const currentPlayer = listOfPlayers.current.find(
        (player) => player.playerId === session.playerId
      );
      if (currentPlayer.SportGroup !== groupFilter) {
        return false;
      }
    }
    if (userFilter !== "all") {
      const currentPlayer = listOfPlayers.current.find(
        (player) => player.playerId === session.playerId
      );
      const playerName = currentPlayer.Name + " " + currentPlayer.Surname;
      if (playerName !== userFilter) {
        return false;
      }
    }
    return true;
  });

  const handleCopyParameters = () => {
    infoSession.current = {
      ...infoSession.current,
      numOfDistractors: selectedSession[0].numDistractors,
      numberOfPlays: selectedSession[0].numPlays,
      playerSelected: selectedSession[1].playerId,
      secondsToNextPlay: selectedSession[0].timeBetweenPlays,
      secondsForPlayTransition: selectedSession[0].transitionTime,
      seed: selectedSession[0].seed,
      typeOfSession: selectedSession[0].sessionType,
    };
  };
  return sessions.length ? (
    <div className="OtherSessionsContainer">
      <button
        className="OtherSessionsBackButton"
        onClick={() => navigate("/football-session")}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="25"
          width="25"
          viewBox="0 0 512 512"
        >
          <path d="M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z" />
        </svg>
        {translate("volver")}
      </button>
      <div className="OtherSessionsFiltersContainer">
        <div className="filtersTitle">
          <b>{translate("filtros")}</b>
        </div>
        <div className="OtherSessionsFilters">
          <div className="OtherSessionsLabelInput">
            <b>{translate("tipo_de_prueba") + ": "}</b>

            <select
              onChange={handleChangeSessionTypeFilter}
              className="form-select"
            >
              <option value="all" selected>
                {translate("todas")}
              </option>
              {sessionType.map((type) => (
                <option value={type}>{showSessionType(type)}</option>
              ))}
            </select>
          </div>
          <div className="OtherSessionsLabelInput">
            <b>{translate("grupo") + ": "}</b>

            <select onChange={handleChangeGroupFilter} className="form-select">
              <option value="all" selected>
                {translate("todos")}
              </option>
              {group.map((group) => (
                <option value={group}>{group}</option>
              ))}
            </select>
          </div>
          <div className="OtherSessionsLabelInput">
            <b>{translate("nombre_") + ": "}</b>

            <select onChange={handleChangeUserFilter} className="form-select">
              <option value="all" selected>
                {translate("todos")}
              </option>
              {user.map((user) => (
                <option value={user}>{user}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="OtherSessionsTable flex h-full min-h-0 w-full flex-1 flex-col overflow-hidden">
        <b className="OtherSessionsSelectTitle">{translate("seleccionar_sesion")}</b>
        <table className="custom-table flex-none">
          <thead className="">
            <tr>
              <th>{translate("tipo_de_prueba")}</th>
              <th>{translate("apellido")}</th>
              <th>{translate("nombre_")}</th>
              <th>{translate("grupo")}</th>
              <th>{translate("sesion")}</th>
              <th>{translate("estatus")}</th>
              <th>{translate("semilla_aleatoria")}</th>
              <th>{translate("promedio_vc")}</th>
              <th>{translate("promedio_vm")}</th>
              <th>{translate("promedio_vcm")}</th>
              <th>{translate("acierto") + " %"}</th>
              <th>{translate("error") + " %"}</th>
            </tr>
          </thead>
        </table>
        <div className="table-containerA">
          <table className="custom-table">
            <tbody>
              {isSorted ? (
                filteredSessions.map((session) => {
                  let currentPlayer = listOfPlayers.current.find(
                    (player) => player.playerId === session.playerId
                  );
                  return (
                    <tr
                      key={session.sessionId}
                      onClick={() =>
                        handleSelectSession(session, currentPlayer)
                      }
                      className={
                        selectedSession
                          ? selectedSession[0] === session
                            ? "selected-row"
                            : ""
                          : ""
                      }
                    >
                      <td>{showSessionType(session.sessionType)}</td>
                      <td>{currentPlayer.Surname}</td>
                      <td>{currentPlayer.Name}</td>
                      <td>{currentPlayer.SportGroup}</td>
                      <td>
                        {(() => {
                          if (
                            session.videoURL &&
                            typeof session.videoURL === "string" &&
                            session.videoURL.split("/").length > 3
                          ) {
                            const parts = session.videoURL.split("/");
                            const datePart = parts[2] || "";
                            const timePart = (parts[3] || "").split("-")[0] || "";
                            return `${datePart} ${timePart}`;
                          }
                          return "";
                        })()}
                      </td>
                      <td>
                        {session.SessionAnalytics[0]
                          ? session.SessionAnalytics[0].complete === 1
                            ? translate("completo")
                            : translate("incompleto")
                          : 0}
                      </td>
                      <td>{session.seed}</td>
                      <td>
                        {session.SessionAnalytics[0]
                          ? session.SessionAnalytics[0].visuMotorMean
                          : 0}
                      </td>
                      <td>
                        {session.SessionAnalytics[0]
                          ? session.SessionAnalytics[0].motorMean
                          : 0}
                      </td>
                      <td>
                        {session.SessionAnalytics[0]
                          ? session.SessionAnalytics[0].responseMean
                          : 0}
                      </td>
                      <td>
                        {session.SessionAnalytics[0]
                          ? session.SessionAnalytics[0].correctPercentage
                          : 0}
                      </td>
                      <td>
                        {session.SessionAnalytics[0]
                          ? session.SessionAnalytics[0].wrongPercentage
                          : 0}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <svg
                  width="55"
                  height="55"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle className="spinner_b2T7" cx="4" cy="12" r="3" />
                  <circle
                    className="spinner_b2T7 spinner_YRVV"
                    cx="12"
                    cy="12"
                    r="3"
                  />
                  <circle
                    className="spinner_b2T7 spinner_c9oY"
                    cx="20"
                    cy="12"
                    r="3"
                  />
                </svg>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="OtherSessionsInfo">
        {/* Datos del Jugador */}
        <div className="OtherSessionsInfoSection">
          <b className="OtherSessionsSectionTitle">{translate("datos_jugador")}</b>
          <div className="OtherSessionsRow">
            <div className="OtherSessionsLabelInput">
              <b>{translate("nombre_") + ": "}</b>
              <input
                className="form-control form-control-sm input-medium"
                type="text"
                readOnly={true}
                value={selectedSession ? selectedSession[1].Name : ""}
              ></input>
            </div>
            <div className="OtherSessionsLabelInput">
              <b>{translate("apellido") + ": "}</b>
              <input
                className="form-control form-control-sm input-medium"
                type="text"
                readOnly={true}
                value={selectedSession ? selectedSession[1].Surname : ""}
              ></input>
            </div>
            <div className="OtherSessionsLabelInput">
              <b>{translate("grupo") + ": "}</b>
              <input
                className="form-control form-control-sm input-medium"
                type="text"
                value={selectedSession ? selectedSession[1].SportGroup : ""}
                readOnly={true}
              ></input>
            </div>
          </div>
          <div className="OtherSessionsRow">
            <div className="OtherSessionsLabelInput">
              <b>{translate("genero") + ": "}</b>
              <input
                className="form-control form-control-sm input-small"
                type="text"
                readOnly={true}
                value={selectedSession ? selectedSession[1].Gender : ""}
              ></input>
            </div>
            <div className="OtherSessionsLabelInput">
              <b>{translate("edad") + ": "}</b>
              <input
                className="form-control form-control-sm input-small"
                type="text"
                value={
                  selectedSession
                    ? calculateAge(selectedSession[1].Birthday)
                    : ""
                }
                readOnly={true}
              ></input>
            </div>
            <div className="OtherSessionsLabelInput">
              <b>{translate("peso") + ": "}</b>
              <input
                className="form-control form-control-sm input-small"
                type="text"
                readOnly={true}
                value={selectedSession ? selectedSession[1].Weight : ""}
              ></input>
            </div>
            <div className="OtherSessionsLabelInput">
              <b>{translate("altura") + ": "}</b>
              <input
                className="form-control form-control-sm input-small"
                type="text"
                readOnly={true}
                value={selectedSession ? selectedSession[1].Height : ""}
              ></input>
            </div>
          </div>
          <div className="OtherSessionsRow">
            <div className="OtherSessionsLabelInput">
              <b>{translate("categoria") + ": "}</b>
              <input
                className="form-control form-control-sm input-medium"
                type="text"
                readOnly={true}
                value={selectedSession ? selectedSession[1].Category : ""}
              ></input>
            </div>
            <div className="OtherSessionsLabelInput">
              <b>{translate("experiencia") + ": "}</b>
              <input
                className="form-control form-control-sm input-medium"
                type="text"
                readOnly={true}
                value={selectedSession ? selectedSession[1].Experience : ""}
              ></input>
            </div>
            <div className="OtherSessionsLabelInput">
              <b>{translate("posicion") + ": "}</b>
              <input
                className="form-control form-control-sm input-medium"
                type="text"
                readOnly={true}
                value={selectedSession ? selectedSession[1].FieldPosition : ""}
              ></input>
            </div>
            <div className="OtherSessionsLabelInput">
              <b>{translate("extremidad_habil") + ": "}</b>
              <input
                className="form-control form-control-sm input-medium"
                type="text"
                readOnly={true}
                value={selectedSession ? selectedSession[1].SkillfulLeg : ""}
              ></input>
            </div>
          </div>
        </div>

        {/* Datos de la Sesión */}
        <div className="OtherSessionsInfoSection">
          <b className="OtherSessionsSectionTitle">{translate("datos_sesion") || "Datos de la Sesión"}</b>
          <div className="OtherSessionsRow">
            <div className="OtherSessionsLabelInput">
              <b>{translate("tipo_de_prueba") + ": "}</b>
              <input
                className="form-control form-control-sm input-large"
                type="text"
                value={
                  selectedSession
                    ? showSessionType(selectedSession[0].sessionType)
                    : ""
                }
                readOnly={true}
              ></input>
            </div>
            <div className="OtherSessionsLabelInput">
              <b>{translate("sesion") + ": "}</b>
              <input
                className="form-control form-control-sm input-medium"
                type="text"
                value={
                  selectedSession
                    ? selectedSession[0].timestamp.split("T")[0]
                    : ""
                }
                readOnly={true}
              ></input>
            </div>
          </div>
          <div className="OtherSessionsRow">
            <div className="OtherSessionsLabelInput">
              <b>{translate("numero_jugadas") + ": "}</b>
              <input
                className="form-control form-control-sm input-small"
                type="text"
                readOnly={true}
                value={selectedSession ? selectedSession[0].numPlays : ""}
              ></input>
            </div>
            <div className="OtherSessionsLabelInput">
              <b>{translate("tiempo_jugadas") + ": "}</b>
              <input
                className="form-control form-control-sm input-small"
                type="text"
                readOnly={true}
                value={
                  selectedSession ? selectedSession[0].timeBetweenPlays : ""
                }
              ></input>
            </div>
            <div className="OtherSessionsLabelInput">
              <b>{translate("tiempo_transicion") + ": "}</b>
              <input
                className="form-control form-control-sm input-small"
                type="text"
                readOnly={true}
                value={selectedSession ? selectedSession[0].transitionTime : ""}
              ></input>
            </div>
          </div>
        </div>
      </div>
      <div className="OtherSessionsControlSessionButtons">
        <button
          className="OtherSessionsButtons"
          disabled={!selectedSession}
          onClick={handleCopyParameters}
        >
          {translate("copiar_parametros")}
        </button>
        <button
          className="OtherSessionsButtons"
          onClick={deleteSelectedSession}
          disabled={!selectedSession}
        >
          {translate("eliminar_sesion")}
        </button>
        <button
          className="OtherSessionsButtons"
          onClick={handleToAnalizeSession}
          disabled={!selectedSession}
        >
          {translate("abrir_sesion")}
        </button>
      </div>
    </div>
  ) : (
    <div className="OtherSessionsLoading">
      {translate("cargando") + " "}
      <svg
        width="55"
        height="55"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle className="spinner_b2T7" cx="4" cy="12" r="3" />
        <circle className="spinner_b2T7 spinner_YRVV" cx="12" cy="12" r="3" />
        <circle className="spinner_b2T7 spinner_c9oY" cx="20" cy="12" r="3" />
      </svg>
    </div>
  );
};

export default OtherSessions;